import { memo as Memo, Fragment, useState, useCallback, useEffect } from 'react';
import { isBoolean } from 'lodash';

//* Helpers
import formValidation from '@helpers/formValidation';

//* Components
import Tag from '../Tag';
import Input from '../Input';
import FieldErrorMsg from '@components/global/error/FieldErrorMsg';

const TagsInput = Memo((props) => {
    //! States
    const [newVal, setNewVal] = useState('');
    const [vals, setVals] = useState(props.list || []);
    const [errorMsg, setErrorMsg] = useState('');

    //! Value Change
    const onChange = (name, val) => {
        setNewVal(val);
    };

    //! Key Down Submit
    const onKeyDown = (e) => {
        if (e.keyCode === 13 && vals.indexOf(e.target.value) <= -1) {
            const newVals = [...vals, e.target.value];
            validate(newVals);
            setVals(newVals);
            setNewVal('');
        }
    };

    //! Remove Element
    const onRemove = (val) => {
        const newVals = vals.filter((i) => i !== val);
        validate(newVals);
        setVals(newVals);
    };

    //! Calling Parent Component OnChange
    useEffect(() => {
        props.onChange && props.onChange(props.name, vals);
    }, [vals]);

    //! Field Validation
    const validate = useCallback((value) => {
        if (props.realTimeValidate && props.required) {
            const valid = formValidation(value, 'tagsInput', props.errorMsg, !isBoolean(props.required) && props.required);

            !isBoolean(valid) && isBoolean(props.parentError) ? setErrorMsg(valid) : errorMsg && setErrorMsg('');
        }
    });

    //! Parent Component Reset
    useEffect(() => {
        if (props.parentVal !== vals && typeof props.parentVal !== 'object') {
            setVals(props.list || []);
            setNewVal('');
            setErrorMsg('');
        }
    }, [props.parentVal]);

    //! Elements
    const elements = useCallback(() => {
        return vals.map((el) => {
            return (
                <Tag
                    key={el}
                    onRemove={() => onRemove(el)}>
                    {el}
                </Tag>
            );
        });
    }, [vals]);

    return (
        <Fragment>
            <div className={`tags-input-cont ${props.className || ''} ${errorMsg || props.errorMsg ? 'error' : ''}`}>
                <Input
                    value={newVal}
                    name={props.name}
                    parentVal={newVal}
                    onChange={onChange}
                    keyDown={onKeyDown}
                    placeholder={props.placeholder}
                    className={errorMsg || props.errorMsg ? 'error' : ''}
                />

                <div className='tags-el-cont'>{elements()}</div>
            </div>

            <FieldErrorMsg msg={errorMsg || props.errorMsg || null} />
        </Fragment>
    );
});

export default TagsInput;
